export default __webpack_public_path__ + "media/images/users/user-sam-kromstain-270x320-267f84ec3fdf989bde322d2c964daf2f.jpg";